// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".incompatible_browser{z-index:1000000;color:#fff;background:#da345e;position:fixed;bottom:0;width:100%;display:block;font-size:21px;text-align:center;padding:20px 5%;line-height:1.5em;letter-spacing:0.3px}@media screen and (max-width: 62.5625em){.incompatible_browser{font-size:16px}}.incompatible_browser__link{color:#fff;text-decoration:underline;cursor:pointer}.incompatible_browser--01{padding:50px 5%}.incompatible_browser--00{height:100%;padding:25% 5%;font-size:21px}\n", ""]);
// Exports
module.exports = exports;
